(function () {
  'use strict';
  if (window.__aurektoLoaded) return;
  window.__aurektoLoaded = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollLockUntil = 0;
  var scrollCancelled = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function headerHeight() {
    var header = $('[data-aurekto-header]');
    return header ? header.getBoundingClientRect().height : 64;
  }

  ['wheel', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, function () { scrollCancelled = true; }, { passive: true });
  });
  function smoothScrollTo(y) {
    if (reducedMotion) { window.scrollTo(0, y); return; }
    var startY = window.scrollY;
    var diff = y - startY;
    if (Math.abs(diff) < 2) return;
    var dur = Math.min(900, Math.max(350, Math.abs(diff) * 0.4));
    var t0 = null;
    scrollCancelled = false;
    function step(ts) {
      if (scrollCancelled) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, startY + diff * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    setTimeout(function () { if (Math.abs(window.scrollY - y) > 4) window.scrollTo(0, y); }, dur + 120);
  }
  /* Gallery navigation is instant by brand decision — no easing, no smooth scroll. */
  function scrollLeftTo(el, target) {
    el.scrollLeft = Math.max(0, Math.round(target));
  }
  function scrollToSection(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    scrollLockUntil = Date.now() + 1000;
    if (id.indexOf('section-') === 0) setActiveLink(id);
    var y = target.getBoundingClientRect().top + window.scrollY - headerHeight();
    smoothScrollTo(Math.max(0, Math.round(y)));
    return true;
  }

  function syncHeaderHeight() {
    var h = headerHeight();
    if (h > 0) document.documentElement.style.setProperty('--aurekto-header-height', Math.round(h) + 'px');
  }

  function syncHeaderClear() {
    var header = $('[data-aurekto-header]');
    if (!header) return;
    if (header.dataset.transparent !== 'true') { header.classList.remove('is-clear'); return; }
    var hero = $('#section-why');
    var threshold = hero ? Math.max(80, hero.offsetHeight - header.offsetHeight - 40) : 120;
    header.classList.toggle('is-clear', window.scrollY < threshold);
  }

  document.addEventListener('click', function (e) {
    var cue = e.target.closest('[data-aurekto-anchor-btn]');
    if (cue) { e.preventDefault(); scrollToSection('section-idea'); return; }
    var link = e.target.closest('[data-aurekto-anchor]');
    if (!link) return;
    var hash = link.getAttribute('href') || '';
    var idx = hash.indexOf('#');
    if (idx === -1) return;
    var id = hash.slice(idx + 1);
    if (!document.getElementById(id)) return;
    e.preventDefault();
    scrollToSection(id);
    if (history.pushState) history.pushState(null, '', '#' + id);
  });

  function setActiveLink(id) {
    $$('[data-aurekto-navlink]').forEach(function (a) {
      var match = a.getAttribute('href').indexOf('#' + id) !== -1;
      if (match) { a.setAttribute('aria-current', 'location'); } else { a.removeAttribute('aria-current'); }
    });
  }

  var sectionObserver = null;
  function observeSections() {
    if (sectionObserver) sectionObserver.disconnect();
    var sections = $$('.aurekto-section[id^="section-"]');
    if (!sections.length || !('IntersectionObserver' in window)) return;
    var ratios = {};
    sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { ratios[en.target.id] = en.isIntersecting ? en.intersectionRatio : 0; });
      if (Date.now() < scrollLockUntil) return;
      var best = null, bestR = 0;
      Object.keys(ratios).forEach(function (id) { if (ratios[id] > bestR) { bestR = ratios[id]; best = id; } });
      if (best) setActiveLink(best);
    }, { rootMargin: '-15% 0px -35% 0px', threshold: [0, 0.15, 0.3, 0.5, 0.75, 1] });
    sections.forEach(function (s) { sectionObserver.observe(s); });
  }

  document.addEventListener('click', function (e) {
    var bag = e.target.closest('[data-aurekto-bag]');
    if (!bag) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(bag); }
  });

  /* empty-cart "Continue shopping" -> PRODUCT section */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('cart-drawer a, cart-notification a, .cart__warnings a, .template-cart a.button');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/collections/all') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    var drawer = document.querySelector('cart-drawer');
    if (document.getElementById('section-product')) {
      if (drawer && typeof drawer.close === 'function') drawer.close();
      scrollToSection('section-product');
      if (history.pushState) history.pushState(null, '', '#section-product');
    } else {
      window.location.href = ((window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/') + '#section-product';
    }
  });

  function refreshCartCount() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-aurekto-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }
  if (typeof window.subscribe === 'function') {
    try { window.subscribe('cart-update', function () { setTimeout(refreshCartCount, 150); }); } catch (err) {}
  }
  document.addEventListener('cart:refresh', refreshCartCount);

  /* Hide the reviews area while there are zero reviews.
     Supports both the classic widget (.jdgm-rev-widg with data-number-of-reviews)
     and the revamped Vue widget (.jdgm-review-widget, count parsed from text). */
  function reviewCountOf(w) {
    var n = w.getAttribute('data-number-of-reviews');
    if (n !== null && n !== '') return parseInt(n, 10);
    var inner = w.querySelector('[data-number-of-reviews]');
    if (inner) return parseInt(inner.getAttribute('data-number-of-reviews'), 10);
    var txt = (w.textContent || '').replace(/,/g, '');
    if (/no reviews yet|be the first to write/i.test(txt)) return 0;
    var m = txt.match(/(\d+)\s+reviews?/i);
    if (m) return parseInt(m[1], 10);
    return null; /* unknown — widget still hydrating; do nothing */
  }
  function hideEmptyReviews() {
    $$('.jdgm-rev-widg, .jdgm-review-widget').forEach(function (w) {
      var count = reviewCountOf(w);
      if (count === null || isNaN(count)) return;
      var wrap = w.closest('.aurekto-reviews') || w.closest('.shopify-app-block');
      if (!wrap || wrap.hasAttribute('data-aurekto-keep-reviews')) return;
      wrap.style.display = count === 0 ? 'none' : '';
    });
  }
  [1500, 4000, 8000].forEach(function (ms) { setTimeout(hideEmptyReviews, ms); });

  function initHero(scope) {
    $$('[data-aurekto-hero]', scope).forEach(function (hero) {
      var videos = $$('video', hero);
      videos.forEach(function (v) {
        v.muted = true;
        v.addEventListener('playing', function () { v.classList.add('is-playing'); });
        if (reducedMotion) { v.pause(); v.classList.remove('is-playing'); }
        else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      var btn = $('[data-aurekto-hero-pause]', hero);
      if (btn) {
        btn.removeAttribute('onclick');
        if (!btn.dataset.bound) {
          btn.dataset.bound = '1';
          if (reducedMotion) btn.setAttribute('aria-pressed', 'true');
          btn.addEventListener('click', function () {
            var paused = btn.getAttribute('aria-pressed') === 'true';
            videos.forEach(function (v) { if (paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); } });
            btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
          });
        }
      }
      var cue = $('.aurekto-hero__cue', hero);
      if (cue) cue.removeAttribute('onclick');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-idea-state]');
    if (!btn) return;
    var section = btn.closest('[data-aurekto-idea]');
    if (!section) return;
    var state = btn.getAttribute('data-idea-state');
    $$('[data-idea-state]', section).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    $$('[data-idea-img]', section).forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-idea-img') === state); });
    $$('[data-idea-caption]', section).forEach(function (c) { c.hidden = c.getAttribute('data-idea-caption') !== state; });
  });

  function initProduct(scope) {
    $$('[data-aurekto-product]', scope).forEach(function (root) {
      if (root.dataset.inited) return;
      root.dataset.inited = '1';
      var dataEl = $('script[data-aurekto-variants]', root);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var form = $('form[data-type="add-to-cart-form"]', root);
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEls = $$('[data-aurekto-price]', root);
      var skuEl = $('[data-aurekto-sku]', root);
      var invEl = $('[data-aurekto-inventory]', root);
      var nameEls = $$('[data-aurekto-color-name]', root);
      var submitBtn = $('.product-form__submit', root);
      var gallery = $('[data-aurekto-gallery]', root);
      var dotsWrap = $('[data-aurekto-dots]', root);
      var stickyBar = $('[data-aurekto-stickybar]', root);
      var soldOutText = root.dataset.textSoldOut || 'Sold out';
      var addText = root.dataset.textAdd || 'Add to bag';

      function findVariant(color) {
        for (var i = 0; i < variants.length; i++) { if (variants[i].option === color) return variants[i]; }
        return variants[0];
      }

      function visibleSlides() {
        return $$('[data-color]', gallery).filter(function (s) { return !s.hidden; });
      }

      function slideTarget(s) { return s.offsetLeft - gallery.offsetLeft; }

      function buildDots() {
        if (!dotsWrap || !gallery) return;
        dotsWrap.innerHTML = '';
        var slides = visibleSlides();
        slides.forEach(function (s, i) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
          if (i === 0) b.setAttribute('aria-current', 'true');
          b.addEventListener('click', function () { scrollLeftTo(gallery, slideTarget(s)); });
          li.appendChild(b); dotsWrap.appendChild(li);
        });
      }

      function currentIndex() {
        var slides = visibleSlides();
        var base = gallery.getBoundingClientRect().left;
        var cur = 0;
        slides.forEach(function (s, i) { if (s.getBoundingClientRect().left - base <= gallery.clientWidth / 2) cur = i; });
        return cur;
      }

      function syncDots() {
        if (!dotsWrap || !gallery) return;
        var idx = currentIndex();
        $$('button', dotsWrap).forEach(function (b, i) { if (i === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      }
      if (gallery) { var t; gallery.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(syncDots, 80); }, { passive: true }); }

      function goSlide(dir) {
        var slides = visibleSlides();
        if (!slides.length || !gallery) return;
        var idx = Math.max(0, Math.min(slides.length - 1, currentIndex() + dir));
        scrollLeftTo(gallery, slideTarget(slides[idx]));
      }
      var prevBtn = $('[data-aurekto-prev]', root), nextBtn = $('[data-aurekto-next]', root);
      if (prevBtn) prevBtn.addEventListener('click', function () { goSlide(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goSlide(1); });

      function filterGallery(colorHandle) {
        if (!gallery) return;
        var any = false;
        $$('[data-color]', gallery).forEach(function (slide) {
          var c = slide.getAttribute('data-color');
          var show = !c || c === 'all' || c === colorHandle;
          slide.hidden = !show;
          if (show) any = true;
        });
        if (!any) $$('[data-color]', gallery).forEach(function (s) { s.hidden = false; });
        gallery.scrollLeft = 0;
        buildDots();
      }

      function applyVariant(variant, opts) {
        opts = opts || {};
        if (!variant) return;
        if (idInput) { idInput.value = variant.id; idInput.disabled = !variant.available; }
        priceEls.forEach(function (el) { el.textContent = variant.price; });
        if (skuEl) skuEl.textContent = variant.sku || '';
        if (invEl) { invEl.textContent = variant.available ? invEl.dataset.inStock : invEl.dataset.outStock; }
        nameEls.forEach(function (el) { el.textContent = variant.option; });
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          var span = submitBtn.querySelector('span');
          if (span) span.textContent = variant.available ? addText : soldOutText;
        }
        if (stickyBar) {
          var sv = $('[data-aurekto-sticky-variant]', stickyBar);
          var sp = $('[data-aurekto-sticky-price]', stickyBar);
          var sb = $('button', stickyBar);
          if (sv) sv.textContent = variant.option;
          if (sp) sp.textContent = variant.price;
          if (sb) { sb.disabled = !variant.available; sb.textContent = variant.available ? addText : soldOutText; }
        }
        filterGallery(variant.handle);
        if (!opts.skipUrl && history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            history.replaceState(null, '', url.toString());
          } catch (err) {}
        }
      }

      root.addEventListener('change', function (e) {
        var input = e.target.closest('input[data-aurekto-color]');
        if (!input) return;
        applyVariant(findVariant(input.value));
      });

      document.addEventListener('aurekto:set-color', function (e) {
        var color = e.detail && e.detail.color;
        if (!color) return;
        var inputs = $$('input[data-aurekto-color]', root);
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === color) { inputs[i].checked = true; applyVariant(findVariant(color)); break; }
        }
      });

      if (stickyBar && 'IntersectionObserver' in window) {
        var productSection = root.closest('.aurekto-section') || root;
        var ctaGuard = document.querySelector('[data-aurekto-cta-buy]');
        var productVisible = false, ctaVisible = false, drawerOpen = false;
        var syncBar = function () { stickyBar.classList.toggle('is-visible', productVisible && !ctaVisible && !drawerOpen); };
        new IntersectionObserver(function (en) { productVisible = en[0].isIntersecting; syncBar(); }, { rootMargin: '100px 0px -20% 0px' }).observe(productSection);
        if (ctaGuard) new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; syncBar(); }, {}).observe(ctaGuard);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && 'MutationObserver' in window) {
          new MutationObserver(function () { drawerOpen = drawer.classList.contains('active') || drawer.classList.contains('animate'); syncBar(); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
        }
        var stickyBtn = $('button', stickyBar);
        if (stickyBtn) stickyBtn.addEventListener('click', function () {
          if (submitBtn && !submitBtn.disabled) { submitBtn.click(); return; }
          /* Card Studio gate (photo / consent still pending): never fail silently —
             scroll the buyer to the gate hint so they can see what is missing. */
          var hint = document.querySelector('[data-acs-gatehint]:not([hidden])') || document.querySelector('[data-acs]') || submitBtn;
          if (hint) {
            var y = hint.getBoundingClientRect().top + window.scrollY - headerHeight() - 90;
            smoothScrollTo(Math.max(0, Math.round(y)));
          }
        });
      }

      var checked = $('input[data-aurekto-color]:checked', root);
      applyVariant(checked ? findVariant(checked.value) : variants[0], { skipUrl: true });
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-aurekto-color-set]');
    if (!chip) return;
    var color = chip.getAttribute('data-aurekto-color-set');
    var wrap = chip.closest('[data-aurekto-cta-colors]');
    if (wrap) $$('[data-aurekto-color-set]', wrap).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
    document.dispatchEvent(new CustomEvent('aurekto:set-color', { detail: { color: color } }));
  });

  function initAll(scope) {
    syncHeaderHeight();
    syncHeaderClear();
    observeSections();
    initHero(scope || document);
    initProduct(scope || document);
    hideEmptyReviews();
  }

  window.addEventListener('scroll', syncHeaderClear, { passive: true });
  window.addEventListener('resize', function () { syncHeaderHeight(); }, { passive: true });
  window.addEventListener('load', function () { initAll(); });
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section) { $$('[data-aurekto-product]', section).forEach(function (r) { delete r.dataset.inited; }); }
    initAll(section || document);
  });
})();